import { render, staticRenderFns } from "./StudentHistorySearch.vue?vue&type=template&id=3076ebfa&"
import script from "./StudentHistorySearch.vue?vue&type=script&lang=js&"
export * from "./StudentHistorySearch.vue?vue&type=script&lang=js&"
import style0 from "./StudentHistorySearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports